import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { UserPayload } from "src/app/models/user-payload.model";
import { AuthService } from "../services/auth.service";
import { filter, take } from "rxjs";

const allowedRoutes = ['/landing-view', '/terms-of-use', '/dull-list', '/create-dull', '/error-page'
    , '/dull-gallery', '/camera-view', '/image-view', '/dull-grade-result', '/research-bit-popup'];

@Injectable()
export class PageAuthGuard {

    public userPayload: UserPayload = { Email: '' };

    constructor(
        private router: Router,
        private auth: AuthService,
    ) { }

    async canActivate(): Promise<boolean> {
        await this.auth.waitForMsalReady();
        const isAuthenticated = this.auth.isAuthenticated();
        const currentRoute = this.router.url;

        if (isAuthenticated) {
            return new Promise((resolve) => {
                this.auth.permissionsLoaded$.pipe(
                    filter(loaded => loaded),
                    take(1)
                ).subscribe(() => {
                    this.handleNavigation();
                    resolve(true);
                });
            });
        }
        else if (!isAuthenticated || !allowedRoutes.includes(currentRoute)) {
            this.router.navigate(['/']);
            return false;
        }
        return true;
    }

    public handleNavigation() {
        if (!this.auth.hasAcceptedTerms()) {
            this.router.navigate(['/terms-of-use']);
        }
    }
}